import { Icon } from "@iconify/react";
import { Radio } from "../common";

const BusinessTimeRadioGroup = ({
  showLabelIcon = false,
  label,
  times,
  activedIndex,
  onSelect,
}) => {
  return (
    <div className="flex flex-col gap-2">
      {label && (
        <div className="flex flex-row items-center gap-2">
          {showLabelIcon && (
            <Icon icon="mdi:clock-outline" className="w-4 h-4 text-primary" />
          )}
          <label className="text-sm font-medium">{label}</label>
        </div>
      )}
      <div className="grid lg:grid-cols-4 grid-cols-2 gap-3">
        {times.map((time, index) => (
          <Radio
            key={index}
            actived={activedIndex === index}
            className="py-2.5 rounded-[14px]"
            onClick={() => onSelect(index)}
          >
            <span
              className={`${
                activedIndex === index ? "text-primary" : "text-dark-blue"
              }`}
            >
              {time}
            </span>
          </Radio>
        ))}
      </div>
    </div>
  );
};

export default BusinessTimeRadioGroup;
